namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class MaritialStatusEditor extends Serenity.Select2Editor<any, any> {

            constructor(container: JQuery) {
            super(container, null);


                this.addOption("Married", "Married");
                this.addOption("Unmarried", "Unmarried");
                //this.addOption("Others","Others");

        }
    }
}